import Swiper from "swiper/bundle";


function createTimelineSlider() {
    const container = document.querySelector(".timeline-slider");
    if (!container) return;


    const swiperElement = container.querySelector('.swiper');
    const timelineDots = container.parentElement.querySelectorAll('.timeline-dot');
    const progressLine = container.parentElement.querySelector('.timeline-progress-line');
    const prevBtn = container.querySelector('.prev');
    const nextBtn = container.querySelector('.next');

    let swiper = null;
    let totalSlides = 0;
    let currentIndex = 0;

    // Initialize Swiper
    function initSwiper() {
        swiper = new Swiper(swiperElement, {
            slidesPerView: 1,
            spaceBetween: 30,
            speed: 600,
            autoHeight:true,

            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            on: {
                slideChange: () => {
                    currentIndex = swiper.activeIndex;
                    updateTopNavigation();
                    updateNavButtons();
                }
            }
        });

        totalSlides = swiper.slides.length;
        updateTopNavigation();
        updateNavButtons();
    }

    // Update top timeline navigation
    function updateTopNavigation() {
        // Update dots
        timelineDots.forEach((dot, index) => {
            if (index === currentIndex) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });

        // Update progress line - increase by 9rem on each slide
        if (progressLine) {
            const progressWidth = (currentIndex * 7.5);
            progressLine.style.width = `${progressWidth}rem`;
        }
    }

    // Update navigation buttons
    function updateNavButtons() {
        if (prevBtn) {
            prevBtn.disabled = currentIndex === 0;
        }

        if (nextBtn) {
            nextBtn.disabled = currentIndex === totalSlides - 1;
        }
    }

    // Navigate to specific slide
    function goToSlide(index) {
        if (swiper && index >= 0 && index < totalSlides) {
            swiper.slideTo(index);
        }
    }

    // Bind events
    function bindEvents() {
        // Timeline dot navigation
        timelineDots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                goToSlide(index);
            });
        });

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                swiper.slidePrev();
            } else if (e.key === 'ArrowRight') {
                swiper.slideNext();
            }
        });
    }

    // Destroy function
    function destroy() {
        if (swiper) {
            swiper.destroy(true, true);
            swiper = null;
        }
    }

    // Initialize everything
    initSwiper();
    bindEvents();

    return {
        swiper,
        goToSlide,
        destroy
    };
}



export { createTimelineSlider };
